import React from "react";
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { NumberField } from '../common/Inputs';
import { Panel, Button, Alert } from 'react-bootstrap';
import {
    getSettings as getSettingsAction,
    updateSettings as updateSettingsAction,
    clearUpdateSettings as clearUpdateSettingsAction
} from "../../actions/settings";
import * as fetchingState from '../../constants/fetchingState';
import * as permissions from '../../constants/permissions';

import { delivery } from '../../constants/settingTypes';

const validate = ({ DeliveryPrice, FreeDeliveryAmount }) => {
    const errors = {};

    if (parseFloat(DeliveryPrice) < 0)
        errors.DeliveryPrice = "*Цена за доставку должна быть больше 0";

    if (parseFloat(FreeDeliveryAmount) < 0)
        errors.FreeDeliveryAmount = "*Сумма после которой доставка бесплатная должна быть больше 0";

    return errors;
}

let DeliverySettings = class extends React.Component {
    constructor(props) {
        super(props);

        this._onSubmit = this._onSubmit.bind(this);
        this._resetForm = this._resetForm.bind(this);
        this._load = this._load.bind(this);
    }

    _onSubmit(values) {
        this.props.updateSettingsAction(delivery, values);
    }

    _resetForm() {
        this.props.clearUpdateSettingsAction(delivery);
    }

    _load() {
        this.props.clearUpdateSettingsAction(delivery);
        this.props.getSettingsAction(delivery);
    }

    componentDidMount() {
        this.props.getSettingsAction(delivery);
    }

    render() {
        const { handleSubmit, fetching, updateFetching, crudError } = this.props;
        const formVisible = fetching === fetchingState.FETCHED && updateFetching === fetchingState.INITIAL;
        const isReadOnly = !permissions.isAllowedFor(permissions.allowedEditSettings);
        return (
            <Panel>
                <Panel.Heading>Доставка</Panel.Heading>
                <Panel.Body>
                    {formVisible && <form className='form-horizontal'>
                        <div>
                            <Field disabled={isReadOnly} name='DeliveryPrice' component={NumberField} label='Цена доставки' min={0} />
                            <Field disabled={isReadOnly} name='FreeDeliveryAmount' component={NumberField} label='Бесплатная доставка' min={0} />
                        </div>
                        <div style={{ margin: '5px', marginTop: '15px', float: 'right' }}>
                            <Button disabled={isReadOnly} bsStyle="success" type="submit" onClick={handleSubmit(this._onSubmit)}>Сохранить</Button>
                        </div>
                    </form>}
                    {fetching === fetchingState.FETCHING && <Alert bsStyle='info'>Загрузка...</Alert>}
                    {fetching === fetchingState.FAILED && <Alert bsStyle='danger'>Ошибка загрузки</Alert>}
                    {updateFetching === fetchingState.FETCHING && <Alert bsStyle='info'>Пожалуйста, подождите...</Alert>}
                    {updateFetching === fetchingState.FETCHED && <div>
                        <Alert bsStyle='success'>Настройки успешно обновлены</Alert>
                        <Button bsStyle="primary" onClick={this._resetForm}>Закрыть</Button>
                    </div>}
                    {updateFetching === fetchingState.FAILED && <div>
                        <Alert bsStyle='danger'>
                            <p>ОШИБКА!</p>
                            {crudError && <p>{crudError}</p>}
                        </Alert>
                        <Button onClick={this._load}>Закрыть</Button>
                    </div>}
                </Panel.Body>
            </Panel>);
    }
}

DeliverySettings = reduxForm({
    form: 'deliverySettingsEdit',
    validate,
    enableReinitialize: true
})(DeliverySettings);

DeliverySettings = connect(state => {
    const { data, fetching, updateFetching } = state.application.get('settings')[delivery];
    return { initialValues: data, fetching, updateFetching }
}, {
    getSettingsAction,
    updateSettingsAction,
    clearUpdateSettingsAction
})(DeliverySettings);

export default DeliverySettings;


// WEBPACK FOOTER //
// ./src/components/settings/Delivery.jsx